import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const QR_PREFIX = 'SI1.';

/**
 * Public page the fleet links to on WhatsApp. The QR token and code are in the
 * URL fragment, which browsers never send to the server, so this page makes no
 * request: it only draws the QR for the attendant to scan.
 */
export function QrShare() {
  const [params] = useState(() => new URLSearchParams(window.location.hash.slice(1)));
  const token = params.get('t') ?? '';
  const code = (params.get('c') ?? '').replace(/\D/g, '');
  const valid = token.startsWith(QR_PREFIX) && token.length < 200;
  const [svg, setSvg] = useState('');
  useEffect(() => {
    if (valid) void QRCode.toString(token, { type: 'svg', errorCorrectionLevel: 'M', margin: 1 }).then(setSvg);
  }, [token, valid]);
  return (
    <main className="qr-share">
      <div className="card stack" style={{ textAlign: 'center', maxWidth: 420, margin: '24px auto' }}>
        {valid ? (
          <>
            <h1>Show this at the pump</h1>
            <div className="qr" role="img" aria-label="QR code for the pump" dangerouslySetInnerHTML={{ __html: svg }} />
            {code.length === 8 ? <><p>Or tell the attendant this code:</p><div className="code">{code.slice(0, 4)} {code.slice(4)}</div></> : null}
            <p className="muted">Works once, only at the pump named in the message. Turn up the screen brightness if the scan is slow.</p>
          </>
        ) : (
          <>
            <h1>Link incomplete</h1>
            <p>Open the full link from the WhatsApp message, or tell the attendant the 8-digit code in it.</p>
          </>
        )}
      </div>
    </main>
  );
}
